import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from '@dmp/components/ui/Button/Button';
import { ROUTE_PATHS } from '@dmp/constant';
import { UserDropdown } from '@dmp/layouts/_share_/UserDropdown/UserDropdown';
import { resetDataHubState } from '@dmp/pages/DataHub/DataHub.store';

/**
 * Logged-in user actions component
 * Shows Datahub link and user profile dropdown for authenticated users
 */
export const LoggedInActions = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDataHubPage = location.pathname.includes(ROUTE_PATHS.DATA_HUB);

  const handleDatahubClick = () => {
    if (window.location.pathname === ROUTE_PATHS.DATA_HUB) {
      window.location.reload();
    } else {
      resetDataHubState();
      navigate(ROUTE_PATHS.DATA_HUB);
    }
  };

  return (
    <div className="flex items-center gap-3 md:gap-4 lg:gap-8">
      <Button
        variant="text"
        onClick={handleDatahubClick}
        className={isDataHubPage ? 'active-data-hub' : ''}
        data-testid="datahub-link"
      >
        Datahub
      </Button>

      <UserDropdown />
    </div>
  );
};
